import { Component, OnInit } from '@angular/core';
import { keyService } from '../api-services/keycloak/service/key.service';
import * as appConstants from '../../assets/json/applicationConstants.json';

@Component({
  selector: 'app-talktodoctorlanding',
  templateUrl: './talktodoctorlanding.component.html',
  styleUrls: ['./talktodoctorlanding.component.css']
})
export class TalktodoctorlandingComponent implements OnInit {
  brandData = appConstants?.commonAppConstants?.brandData;
  getToken: any =false;
  constructor(private kc:keyService) {
    
    
   }

  async ngOnInit() {
    this.getToken =await this.kc.isLoggedIn()

  }
  
  

}
